import { Search } from '@mui/icons-material'
import { Paper, PaperProps, Typography, TypographyProps, useTheme } from '@mui/material'
import { ReactNode } from 'react'

interface EmptyStateProps extends PaperProps {
  icon?: ReactNode
  title: string
  children?: JSX.Element
  slotProps?: {
    title: Omit<TypographyProps, 'children'>
  }
}

export default function EmptyState({
  icon,
  title,
  children,
  slotProps,
  sx,
  ...props
}: EmptyStateProps) {
  const theme = useTheme()

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: '2rem',
        ...sx
      }}
      {...props}
    >
      {icon ? icon : <Search fontSize="large" />}
      <Typography
        color="text.secondary"
        sx={{ mt: '1rem', textAlign: 'center' }}
        {...slotProps?.title}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  )
}
